module.exports = __webpack_public_path__ + "static/media/GMCNgine3.5948a2e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/Dashboard/Partners/images/GMCNgine3.png
// module id = 2540
// module chunks = 1